var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LayoutTicket',{attrs:{"title":"Tickets","navPath":"/tickets","sopType":_vm.sopType}})
}
var staticRenderFns = []

export { render, staticRenderFns }